import { Link } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';
import { Header, Footer, PageTransition } from '../components';
import { SEOHead } from '../components/seo';
import { Icon } from '../components/ui/Icon';

function NotFoundPage() {
  const props = useSpring({
    from: { transform: 'translateY(0px)' },
    to: async (next) => {
      // Infinite animation loop
      while (true) {
        await next({ transform: 'translateY(-20px)' });
        await next({ transform: 'translateY(0px)' });
      }
    },
    config: { tension: 120, friction: 14 },
  });

  return (
    <div className="min-h-screen bg-gray-950 flex flex-col">
      <SEOHead
        title="404 - Page Not Found | EasyBuy"
        description="The page you are looking for has vanished into our global supply chain."
      />
      <Header />
      <PageTransition>
        <main className="flex-grow flex items-center justify-center relative overflow-hidden py-20">
        {/* Background Elements */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-orange-500/10 rounded-full blur-3xl"></div>
          <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
        </div>

        <div className="text-center z-10 px-4 relative">
          <animated.h1 style={props} className="text-[10rem] md:text-[16rem] font-bold text-gray-800 leading-none select-none opacity-50">
            404
          </animated.h1>

          <div className="-mt-12 md:-mt-20 relative z-20">
            <h2 className="text-4xl md:text-6xl font-bold text-white mb-6 tracking-tight">
              Lost in <span className="text-orange-500">Transit?</span>
            </h2>
            <p className="text-xl text-gray-400 max-w-lg mx-auto mb-10 leading-relaxed border-l-2 border-orange-500 pl-6 text-left md:text-center md:border-l-0 md:pl-0">
              The page you are looking for seems to have gone off-grid or vanished into our global supply chain.
              Let's get you back to safety.
            </p>

            <div className="flex flex-col md:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white rounded-full font-bold transition-all transform hover:scale-105 shadow-lg shadow-orange-500/25"
              >
                <Icon name="home" className="w-5 h-5" />
                <span>Return Home</span>
              </Link>
              <Link
                to="/contact"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-gray-800 hover:bg-gray-700 text-white rounded-full font-bold transition-all transform hover:scale-105"
              >
                <Icon name="message-circle" className="w-5 h-5" />
                <span>Contact Support</span>
              </Link>
            </div>
          </div>
        </div>
      </main>
      </PageTransition>
      <Footer />
    </div>
  );
}

export default NotFoundPage;